const nivelPrioridadEnumerators = {
    clasificacion: [
        'operativa',
        'mantenimiento',
    ],
};

export default nivelPrioridadEnumerators;
